import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'reflexbox'
import { connect } from 'react-redux'

import Navigation from './SpecificationNavigation'
import {
  formattedCategoriesSelector,
} from './selectors'
import {
  onSave,
} from './actions'

const mapStateToProps = (state) => {
  return {
    categories: formattedCategoriesSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSave: () => dispatch(onSave()),
  }
}

class Sidebar extends Component {
  static propTypes = {
    partnerSite: PropTypes.string.isRequired,
    productSku: PropTypes.string.isRequired,
    productBrand: PropTypes.string.isRequired,
    gpuSku: PropTypes.string.isRequired,
    categories: PropTypes.array.isRequired,
  }

  onSave = () => this.props.onSave()

  getCategories() {
    var toReturn = this.props.categories.slice()
    toReturn.push({key: 'Schedule', label: 'Schedule'})
    return toReturn
  }

  render() {

    return (
      <Flex auto column>
        <Navigation categories={this.getCategories()} containerId='mainContainer'/>
        {/*<ActionButtons onSave={this.onSave}/>*/}
      </Flex>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

export default withConnect(Sidebar)
